import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MedicationLiquidIcon(props: IconProps) {
    return <Icon {...props} iconKey={"medication_liquid"}/>
}
